import { useQuery } from '@tanstack/react-query';
import type { InventoryHistoryItem } from '@/lib/api-admin/types';
import type { ApiMeta } from '@/lib/http-core';
import { apiClient } from '@/lib/apiClient';

export interface InventoryHistoryQueryParams {
  inventoryId?: number;
  page?: number;
  size?: number;
}

export interface InventoryHistoryPage {
  items: ReadonlyArray<InventoryHistoryItem>;
  meta: ApiMeta;
}

export const inventoryHistoryQueryKey = (params: InventoryHistoryQueryParams) =>
  ['admin', 'inventory', 'history', params] as const;

export const useInventoryHistoryQuery = (params: InventoryHistoryQueryParams) =>
  useQuery<InventoryHistoryPage>({
    queryKey: inventoryHistoryQueryKey(params),
    queryFn: async () => {
      const query: Record<string, unknown> = {
        page: Math.max(0, (params.page ?? 1) - 1),
      };
      if (params.size) query.size = params.size;
      if (params.inventoryId) query.inventoryId = params.inventoryId;
      const [data, meta] = await apiClient.request('get', '/admin/v1/inventory/history', {
        params: { query },
      });
      return { items: (data as InventoryHistoryItem[]) ?? [], meta };
    },
  });
